import request from "@/request";

export const getTypeList = (params) =>
  request.get("/api/system/dicts", { params });
export const getBuildingTypeList = (params) =>
  request.get("/api/buildingtypes/array", { params });
